import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiBox from '@mui/material//Box';
import useScrollCapture from '../../hooks/useScrollCapture/useScrollCapture.js';
import 'react';
import 'react-highlight-words';
import getScrollFadeStyles from '../../utils/getScrollFadeStyles.js';
import 'date-fns';

const getBorderInScroll = (theme, scrollPosition) => {
    if (scrollPosition === 'top') {
        return `border-bottom-color: ${theme.palette.N30.main}`;
    }
    else if (scrollPosition === 'bottom') {
        return `border-top-color: ${theme.palette.N30.main}`;
    }
    else {
        return `
    border-top-color: ${theme.palette.N30.main};
    border-bottom-color: ${theme.palette.N30.main};
    `;
    }
};
const ScrollContainer = styled(MuiBox, {
    shouldForwardProp: prop => !['scrollPosition', 'hasScrollbar'].includes(prop),
}) `
  display: flex;
  width: 100%;
  border: 1px solid transparent;
  flex: 1;
  overflow: none;
  ${({ theme, scrollPosition, hasScrollbar }) => `
      padding: ${theme.spacing(0, 5, 0, 8)};
      transition: box-shadow linear ${theme.transitions.duration.fast}, border linear ${theme.transitions.duration.fast};
      ${hasScrollbar && scrollPosition && `box-shadow: ${getScrollFadeStyles(theme, true, true)[scrollPosition]}`};
      ${hasScrollbar && scrollPosition && getBorderInScroll(theme, scrollPosition)};
    `}
`;
const ScrollableContent = styled(MuiBox, {
    shouldForwardProp: prop => !['responsive'].includes(prop),
}) `
  display: flex;
  flex: 1;
  overflow-y: scroll;
  overflow-x: none;
  @-moz-document url-prefix() {
    overflow: auto;
  }
  padding: ${({ theme }) => theme.spacing(0.5)};
  ${({ responsive }) => `
      ${responsive ? 'flex-grow: 1' : 'max-height: 500px'};
      width: ${responsive ? '40vw' : '100%'};
      height: ${responsive ? '50vh' : 'fit-content'};
    `}
`;
const DialogScrollContent = (_a) => {
    var { responsive, children } = _a, rest = __rest(_a, ["responsive", "children"]);
    const { scrollRef, scrollPosition, hasScrollbar } = useScrollCapture();
    return (jsx(ScrollContainer, Object.assign({ scrollPosition: scrollPosition, hasScrollbar: hasScrollbar }, rest, { children: jsx(ScrollableContent, Object.assign({ id: "content", ref: scrollRef, responsive: responsive, className: "scrollableContent styled-scrollbar" }, { children: children })) })));
};

export { DialogScrollContent as default };
//# sourceMappingURL=DialogScrollContent.js.map
